import { Link } from "react-router-dom";

export default function Footer({ settings }) {
  return (
    <footer className="bg-[#1C1C1B] text-white/80 mt-20">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="logo-mark text-white text-2xl mb-3 leading-[0.9]">
            <span className="block">OASI</span>
            <span className="block">BAGNI<sup className="text-[9px] ml-0.5 align-top">®</sup></span>
          </div>
          <p className="text-sm leading-relaxed text-white/60 mt-4">Un metodo chiaro, materiali selezionati e un unico team dalla prima idea alla consegna del bagno.</p>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-[var(--oasi-sand)] mb-4">Navigazione</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/metodo-oasi" className="hover:text-white">Metodo Oasi</Link></li>
            <li><Link to="/pacchetti" className="hover:text-white">Pacchetti</Link></li>
            <li><Link to="/super-garanzia" className="hover:text-white">Super Garanzia</Link></li>
            <li><Link to="/guida-ristrutturazione-bagno" className="hover:text-white">Guida gratuita</Link></li>
            <li><Link to="/prenota-sopralluogo" className="hover:text-white">Richiedi sopralluogo</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-[var(--oasi-sand)] mb-4">Contatti</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li>{settings?.phone}</li>
            <li>{settings?.notification_email}</li>
            <li>{settings?.address}</li>
            <li className="text-white/50 text-xs mt-3">Zone: {settings?.served_areas}</li>
          </ul>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-[var(--oasi-sand)] mb-4">Legale</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/cookie" className="hover:text-white">Cookie Policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6">
        <div className="max-w-7xl mx-auto px-5 md:px-10 text-[11px] leading-relaxed text-white/45 grid md:grid-cols-2 gap-3">
          <div>
            <strong className="text-white/60">Oasi Bagni</strong> è un brand di {settings?.company_name}. Sede legale: {settings?.address}. P. IVA / C.F.: {settings?.vat_cf}.
          </div>
          <div>
            {settings?.business_register}. REA: {settings?.rea}. Capitale sociale: {settings?.share_capital}. PEC: {settings?.pec}. Email: {settings?.notification_email}.
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/40">
        © {new Date().getFullYear()} Oasi Bagni®. Tutti i diritti riservati.
      </div>
    </footer>
  );
}
